import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ActivatePage } from './pages/ActivatePage';
import { DiagnosisPage } from './pages/DiagnosisPage';
import { GuidePage } from './pages/GuidePage';
import { HomePage } from './pages/HomePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { RefundPage } from './pages/RefundPage';

export function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/activate" element={<ActivatePage />} />
        <Route path="/diagnose/:issueId" element={<DiagnosisPage />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/refund" element={<RefundPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
}
